module.exports = __webpack_public_path__ + "static/media/empty.5620a0c6.svg";